import React from 'react';

const StudyModeToggleTailwind = ({ studyMode, onToggle, isAuthenticated }) => {
  if (!isAuthenticated) {
    return (
      <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">
              🎯 Interactive Study Mode
            </h3>
            <p className="text-sm text-blue-600 mt-1">
              Sign in to unlock AI-powered questions, explanations, and clarifications for every line of content. 
              Transform static reading into active learning!
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 flex items-center justify-between p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-blue-900">
            🎯 Interactive Study Mode
          </h3>
          <p className="text-sm text-blue-700">
            AI-powered questions and explanations for every line of content
          </p>
        </div>
      </div>
      
      <div className="flex items-center">
        <label className="flex items-center cursor-pointer">
          <div className="relative">
            <input
              type="checkbox"
              checked={studyMode}
              onChange={(e) => onToggle(e.target.checked)}
              className="sr-only"
            />
            <div className={`block w-14 h-8 rounded-full transition-colors duration-200 ease-in-out ${
              studyMode ? 'bg-blue-600' : 'bg-gray-300'
            }`}></div>
            <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform duration-200 ease-in-out ${
              studyMode ? 'transform translate-x-6' : ''
            }`}></div>
          </div>
          <div className="ml-3">
            <span className={`text-sm font-medium ${studyMode ? 'text-blue-900' : 'text-gray-600'}`}>
              {studyMode ? 'ON' : 'OFF'}
            </span>
          </div>
        </label>
      </div>
    </div>
  );
};

export default StudyModeToggleTailwind;